export const REASONS = [
  // labelKey is used for i18n; label is a fallback
  { id: 'expensive', emoji: '💸', labelKey: 'CancelFlow_Reason_expensive', label: 'Too expensive' },
  { id: 'toomuch', emoji: '📦', labelKey: 'CancelFlow_Reason_toomuch', label: 'I have too much product' },
  { id: 'taste', emoji: '😕', labelKey: 'CancelFlow_Reason_taste', label: "I don't like the taste" },
  { id: 'format', emoji: '💊', labelKey: 'CancelFlow_Reason_format', label: "I don't like the format" },
  { id: 'results', emoji: '📊', labelKey: 'CancelFlow_Reason_results', label: 'Not seeing results yet' },
  { id: 'other', emoji: '💬', labelKey: 'CancelFlow_Reason_other', label: 'Other' },
];

export const TASTE_CHIPS = [
  { key: 'CancelFlow_TasteChip_TooBitter', label: 'Too bitter' },
  { key: 'CancelFlow_TasteChip_TooSweet', label: 'Too sweet' },
  { key: 'CancelFlow_TasteChip_TextureIssue', label: 'Texture issue' },
  { key: 'CancelFlow_TasteChip_Smell', label: 'Smell' },
  { key: 'CancelFlow_TasteChip_Aftertaste', label: 'Aftertaste' },
  { key: 'CancelFlow_TasteChip_Other', label: 'Other' },
];

export const FORMAT_CHIPS = [
  { key: 'CancelFlow_FormatChip_Capsules', label: 'Capsules' },
  { key: 'CancelFlow_FormatChip_Tablets', label: 'Tablets' },
  { key: 'CancelFlow_FormatChip_Gummies', label: 'Gummies' },
  { key: 'CancelFlow_FormatChip_LiquidDrops', label: 'Liquid drops' },
  { key: 'CancelFlow_FormatChip_PowderTub', label: 'Powder tub' },
  { key: 'CancelFlow_FormatChip_Other', label: 'Other' },
];

